export default "__VITE_ASSET__DjjZ0RGk__"